<template>
  <div>
    <v-toolbar dark color="highlight" flat class="sticky" dense>
      <v-toolbar-title>{{$t('help')}}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-container>
      <div v-if="items" class="wrapper">
        <v-card outlined class="box" v-for="(helpvm,i) in items" :key="i">
          <v-card-title>{{helpvm.name}}</v-card-title>
          <v-card-text
            ref="helpvm"
            class="content"
            :class="isOverFlow(helpvm,i)  ? 'content' : helpvm.active ? 'content_active': ''"
            v-html="helpvm.description"
          ></v-card-text>
          <v-icon
            @click="collapse(helpvm)"
            color="primary"
            v-if="helpvm.isOverflowing"
            :class="helpvm.active ? 'active': ''"
            class="collapsible"
          >{{helpvm.active ? 'fa-chevron-up': 'fa-chevron-down'}}</v-icon>
          <v-container>
            <ul>
              <li v-for="(document,i) in helpvm.documents" :key="i">
                <v-chip outlined class="ma-2" color="primary" label>
                  <v-icon color="primary" small left>fa-file</v-icon>
                  <a class target="_blank" :href="document.link">{{document.fileName}}</a>
                </v-chip>
              </li>
            </ul>
          </v-container>
        </v-card>
        <p v-show="items.length === 0">{{$t('noresults')}}</p>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Help",
  data() {
    return {
      items: null,
      styleDescriptionAuto: {
        height: "auto"
      }
    };
  },
  methods: {
    isOverFlow(helpvm, i) {
      this.$nextTick(() => {
        if (this.$refs.helpvm) {
          if (helpvm.isOverflowing === undefined) {
            var elements = this.$refs.helpvm;
            let el = elements[i];
            var curOverflow = el.style.overflow;
            if (!curOverflow || curOverflow === "visible")
              el.style.overflow = "hidden";
            var isOverflowing =
              el.clientWidth < el.scrollWidth ||
              el.clientHeight < el.scrollHeight;

            el.style.overflow = curOverflow;

            if (isOverflowing) helpvm.isOverflowing = true;
            else helpvm.isOverflowing = false;
            if (!isOverflowing) el.classList.remove("content");
            this.$forceUpdate();
          }
        } else {
          helpvm.isOverflowing = false;
        }
      });
    },
    collapse(document) {
      document.active = !document.active;
      this.$forceUpdate();
    }
  },
  created() {
    this.$http
      .getHelp()
      .then(res => {
        this.items = res.data;
      })
      .catch(err => {
        console.log(err);
      });
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  --auto-grid-min-size: 20rem;
  display: grid;
  grid-gap: 1em;
  grid-template-columns: repeat(
    auto-fit,
    minmax(var(--auto-grid-min-size), 1fr)
  );
}

.box {
  border-radius: 5px;
  padding: 1em;
  height: auto;
}

.collapsible {
  cursor: pointer;
  padding: 18px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 15px;
}

.content {
  padding: 0 18px;
  max-height: 100px;
  overflow: hidden;
  transition: max-height 0.2s ease-in-out;
  background-color: #f1f1f1;
}
.content_active {
  max-height: 10000px;
  transition: max-height 0.2s ease-in-out;
  background-color: unset;
}
</style>



// WEBPACK FOOTER //
// src/views/help/Index.vue